import React,{useEffect} from "react";
import { useParams, useLocation } from 'react-router-dom';
import Header from "../pages/inc/Header";
import Footer from "../pages/inc/Footer";

import Body from "./TeamMember/Reinhardbonnke";
import Popmodal from "../pages/inc/popmodal";
import Banner from "./About/Banner";

import { useTranslation } from 'react-i18next';



const Home = () => {
  const { t, i18n } = useTranslation()
  const { id } = useParams();
  const location = useLocation();
  let pathPrefix = location.pathname.split('/').length;
  let parameter_dat = id;
  if(pathPrefix > 2){
    pathPrefix = location.pathname.split('/')[0];
    pathPrefix = pathPrefix+'/';
  }
  let titleone_data;
  let lmg_data;
  let titletwo_data;
  let textone;
  let details_pargs;
 
 if(parameter_dat == 2){
  lmg_data = pathPrefix+"img/Reinhard Bonnke_bgremoved.png";
  titleone_data = t("Evangelist_Reinhard_Bonnke_Biography");
  titletwo_data = t("A_Life_On_Fire");
  textone = t("Evangelist_Reinhard_Bonnke_was_principally");
  details_pargs = [
    {title: t("Evangelist_Bonnke_began_holding_meetings"),class:""},
    {title: t("Reinhard_Bonnke_held_the_first_Fire_Conference"),class:""}
  ,{title:"",class:"",
    other_option:[
      {
        contain_before: t("Christ_for_All_Nations_continues_to_be_committed"),
        tag_name:"a",
        title: t("Full_Flame_Film_Series"),
        props_data:{className:"",href:"https://gettheflame.com/",target:"_blank"},
        contain_after: t("eight_inspirational_films_aimed_at_activating")
     }
    ]
  },
  {title: t("Reinhard_Bonnkes_passion_for_the_Gospel"),class:""}
  ,{title: t("Evangelist_Bonnke_is_survived_by_his_beloved_wife"),class:""}
  ]
    }else{
      lmg_data = pathPrefix+"img/Daniel Kolenda.jpg";
      titleone_data = t("Missionary_Evangelist_Daniel_Kolenda");
      titletwo_data = t("Man_On_A_Mission");
      textone = [
        {title: t("Daniel_Kolenda_is_a_missionary_evangelist"),class:""}
      ,{title:"",class:"",
        other_option:[
          {
            contain_before: t("As_the_successor_to_world_renowned"),
            tag_name:"i",
            title: t("LIVE_Before_You_Die"),
            props_data:{className:"design-itliq",href:"",target:"_blank"},
            contain_after:t("and")

         }, 
          {
            contain_before:' ',
            tag_name:"i",
            title: t("Slaying_Dragons"),
            props_data:{className:"",href:"",target:"_blank"},
            contain_after:''

         }
        ]

      },
      ];
      details_pargs = [
        {
          title:"",
          class:"",
        other_option:[
          {
            contain_before: t("In_addition_to_the_international_work"),
            tag_name:"i",
            title: t("Nations_Church"),
            props_data:{className:"design-itliq",href:"",target:"_blank"},
            contain_after:''

         },
         {
            contain_before: t("He_is_the_founder_of_the"),
            tag_name:"i",
            title: t("CfaN_Evangelism_Bootcamp"),
            props_data:{className:"design-itliq",href:"",target:"_blank"},
            contain_after: t("also_located_in_Orlando")

         }
        ], 
        },
        {
          title: t("Daniel_is_a_graduate_of_Southeastern_University"),
          class:""
      
        }
      ]
    }
    const bannerdata = {
        img:lmg_data,
        titleone:titleone_data,
        titletwo:titletwo_data,
        textone:textone,
        texttwo:'',
        textthree:'',
        contentClass:'team-contents'
        
      };
      const { pathname } = useLocation();
      useEffect(() => {
        window.scrollTo(0, 0); 
      }, [pathname]); 
  return (   
    <>
    <Header/>
    <Banner bannerdata={bannerdata}/>
    <Body details_pargs={details_pargs} />
    <Footer/>
    <Popmodal/>
    </>
  );
};

export default Home;